<template>
  <vf-utility-navigation v-bind="forwarded">
    <template #help v-if="$feature.enableLanguagePreference && $languagePref?.get() === 'ES'">
      <vf-link
        to="/help-es"
        variant="quiet"
        @click="$gtm.push('topNav.onClickUtilityLink', 'Help - ES')"
      >
        Ayuda
      </vf-link>
    </template>
  </vf-utility-navigation>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brand/regions/nora/components/vf/utility-navigation/UtilityNavigation.vue'
import VfUtilityNavigation from '#brand/regions/nora/components/vf/utility-navigation/UtilityNavigation.vue'

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emits)
</script>
